<script setup lang="ts">

defineProps<{ color: "danger" | "warning", label: string }>();
const emit = defineEmits( [ "action" ] );

const css = {
    "danger": {
        text: "text-error-500",
        background: "bg-error-500"
    },
    "warning": {
        text: "text-warning-500",
        background: "bg-warning-500"
    }
}

</script>

<template>
    <div class="absolute bottom-[6%] right-[4%] left-[4%] z-10 text-center uppercase">
        <div class="relative z-20 mb-[-1.75rem] pointer-events-none">
            <div class="inline-block p-1 rounded-full bg-gray-800">
                <div class="p-2 rounded-full" :class="css[color].background">
                    <Icon name="exclamation" style="vertical-align: -0.25em;" />
                </div>
            </div>
            <div class="text-lg font-bold leading-4" :class="css[color].text">
                {{ label }}
            </div>
        </div>
        <div class="bg-gray-800 px-5 pb-3 pt-9 rounded-lg relative z-10 cursor-pointer" @click="() => emit( 'action' )">
            <slot />
        </div>
    </div>
</template>